import { render, staticRenderFns } from "./RadioSettings.vue?vue&type=template&id=5f329981&"
import script from "./RadioSettings.vue?vue&type=script&lang=js&"
export * from "./RadioSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports